import { useState } from "react";
import { deepList } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function DeepSection() {
  const [open, setOpen] = useState<boolean[]>(Array(deepList.length).fill(false));
  const toggle = (i: number) => setOpen((prev) => prev.map((v, idx) => (idx === i ? !v : v)));

  return (
    <section id="deep" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="深度讨论"
          title="不止吃瓜，更把来龙去脉讲清楚"
          sub="从热点现象出发，聚合多方声音与专业观点，帮你少看热闹、多看门道。"
          align="center"
        />

        <div className="mt-10 space-y-8">
          {deepList.map((d, i) => (
            <article
              key={d.title}
              className={`flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-100/50 lg:flex-row ${
                i % 2 === 1 ? "lg:flex-row-reverse" : ""
              }`}
            >
              <div className="relative shrink-0 overflow-hidden bg-background-200 lg:w-1/2">
                <img src={d.img} alt={d.title} className="h-56 w-full object-cover lg:h-full" />
                <span className="absolute left-4 top-4 rounded-md bg-primary-500 px-2.5 py-1 text-xs font-bold text-background-50">{d.tag}</span>
              </div>
              <div className="flex flex-col p-6 md:p-8 lg:w-1/2">
                <div className="flex items-center gap-3 text-xs text-foreground-600">
                  <span className="flex items-center gap-1"><i className="ri-calendar-line text-accent-600"></i>{d.date}</span>
                  <span className="flex items-center gap-1"><i className="ri-time-line text-accent-600"></i>阅读约 {d.readTime}</span>
                </div>
                <h3 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[1.7rem]">{d.title}</h3>
                <p className="mt-3 border-l-4 border-secondary-400 pl-3 font-medium text-foreground-800">{d.lead}</p>
                <p className={`mt-3 text-sm leading-relaxed text-foreground-700 transition-all ${open[i] ? "" : "line-clamp-3"}`}>{d.body}</p>
                <button
                  type="button"
                  onClick={() => toggle(i)}
                  className="mt-4 inline-flex w-fit items-center gap-1.5 rounded-md bg-secondary-100 px-4 py-2 text-sm font-bold whitespace-nowrap text-secondary-900 transition-colors hover:bg-secondary-200"
                >
                  {open[i] ? "收起" : "展开全文"}
                  <i className={open[i] ? "ri-arrow-up-line" : "ri-arrow-down-line"}></i>
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}